import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import { Box } from 'pcln-design-system'
import FiltersSection from '../../molecules/FiltersSection'

const propTypes = {
  className: PropTypes.string,
  textCollapsed: PropTypes.string,
  textExpanded: PropTypes.string,
  searchFilterFontSize: PropTypes.string,
  showFirstDivider: PropTypes.bool,
  largeCategoryHeader: PropTypes.bool,
  filterSections: PropTypes.arrayOf(PropTypes.object),
  theme: PropTypes.object.isRequired,
  activeSearch: PropTypes.bool,
  buttonIsGrayWithNoInput: PropTypes.bool,
  priceGuidanceNewLabelStyle: PropTypes.bool,
  showChip: PropTypes.bool,
  hideCloseIcon: PropTypes.bool,
  showSearchIconButton: PropTypes.bool,
  sopqProps: PropTypes.object,
  showLeftRail: PropTypes.bool,
  sopqLearnMore: PropTypes.string,
  dealsDontMove: PropTypes.bool,
}

const defaultProps = {
  showFirstDivider: true,
  largeCategoryHeader: false,
  hideCloseIcon: false,
}

const setDivider = (index, showFirstDivider) => {
  if (index > 0) {
    return true
  }
  if (showFirstDivider) {
    return true
  }
  return false
}

const renderFilterSections = ({
  sections,
  textCollapsed,
  textExpanded,
  showFirstDivider,
  searchFilterFontSize,
  largeCategoryHeader,
  activeSearch,
  buttonIsGrayWithNoInput,
  priceGuidanceNewLabelStyle,
  showChip,
  hideCloseIcon,
  showSearchIconButton,
  sopqProps,
  showLeftRail,
  sopqLearnMore,
  dealsDontMove,
}) => {
  if (!sections || !sections.length) return null
  return sections.map((section, index) => (
    <FiltersSection
      showDivider={setDivider(index, showFirstDivider)}
      key={`filter-section-${index}`}
      buttonIsGrayWithNoInput={buttonIsGrayWithNoInput}
      activeSearch={activeSearch}
      header={section.header}
      priceGuidanceNewLabelStyle={priceGuidanceNewLabelStyle}
      categories={section.categories}
      textCollapsed={textCollapsed}
      textExpanded={textExpanded}
      searchFilterFontSize={searchFilterFontSize}
      largeCategoryHeader={largeCategoryHeader}
      showChip={showChip}
      hideCloseIcon={hideCloseIcon}
      showSearchIconButton={showSearchIconButton}
      showLeftRail={showLeftRail}
      sopqLearnMore={sopqLearnMore}
      sopqProps={sopqProps}
      dealsDontMove={dealsDontMove}
    />
  ))
}

const HotelFilter = ({
  textCollapsed,
  textExpanded,
  searchFilterFontSize,
  filterSections,
  showFirstDivider,
  largeCategoryHeader,
  activeSearch,
  buttonIsGrayWithNoInput,
  priceGuidanceNewLabelStyle,
  showChip,
  hideCloseIcon,
  showSearchIconButton,
  sopqProps,
  showLeftRail,
  sopqLearnMore,
  dealsDontMove,
}) => {
  return (
    <Box>
      {renderFilterSections({
        sections: filterSections,
        textCollapsed,
        textExpanded,
        searchFilterFontSize,
        showFirstDivider,
        largeCategoryHeader,
        buttonIsGrayWithNoInput,
        activeSearch,
        priceGuidanceNewLabelStyle,
        showChip,
        hideCloseIcon,
        showSearchIconButton,
        sopqProps,
        showLeftRail,
        sopqLearnMore,
        dealsDontMove,
      })}
    </Box>
  )
}

HotelFilter.propTypes = propTypes
HotelFilter.defaultProps = defaultProps

export default withTheme(HotelFilter)
